import { SetPasswordReq, UpdateHandleReq, UpdatePasswordReq } from '../dto/ReqDtoRepository';
import {
  ArchiveIndexListResponse,
  MemberSearchListResponse,
  MemberResponse,
  PrerenderProfilesResponse,
  SimpleStringResponse,
} from '../dto/ResDtoRepository';
import { sendApiRequest, sendGetApiRequest } from './apiConfig';
import { ArchiveRole, ExposureLevel, MemberType } from '../enum/EnumRepository';


export const searchMember = async (username: string): Promise<MemberSearchListResponse> => {
  const params = new URLSearchParams({ query: username });
  return sendGetApiRequest<MemberSearchListResponse>(`/api/v1/member/search?${params.toString()}`);
};

/** Work Artist 연결용: 검색 가능한 개인 계정만 요청한다. */
export const searchArtistMember = async (query: string): Promise<MemberSearchListResponse> => {
  const params = new URLSearchParams({
    query,
    memberType: MemberType.INDIVIDUAL,
    archiveRole: ArchiveRole.ARTIST,
    exposureLevels: [ExposureLevel.PUBLIC, ExposureLevel.SEARCHABLE].join(','),
  });
  return sendGetApiRequest<MemberSearchListResponse>(`/api/v1/member/search?${params.toString()}`);
};

/** GroupMember 초대용: 검색 가능한 개인 계정만 요청한다. */
export const searchIndividualMember = async (query: string): Promise<MemberSearchListResponse> => {
  const params = new URLSearchParams({
    query,
    memberType: MemberType.INDIVIDUAL,
    exposureLevels: [ExposureLevel.PUBLIC, ExposureLevel.SEARCHABLE].join(','),
  });
  return sendGetApiRequest<MemberSearchListResponse>(`/api/v1/member/search?${params.toString()}`);
};

/** Archive Index에 노출되는 멤버(PUBLIC). 인증 불필요(`sendGetApiRequest` / publicApi). */
export const getPublicArchiveIndex = async (): Promise<ArchiveIndexListResponse> => {
  return sendGetApiRequest<ArchiveIndexListResponse>('/api/v1/member/archive-index');
};

/** Prerender 대상인 ACTIVE + PUBLIC/SEARCHABLE 멤버. 빌드에서만 사용한다. */
export const getPrerenderProfiles = async (): Promise<PrerenderProfilesResponse> => {
  return sendGetApiRequest<PrerenderProfilesResponse>('/api/v1/member/prerender-profiles');
};

export const updatePassword = async (aui: string, data: UpdatePasswordReq): Promise<MemberResponse> => {
  return sendApiRequest<MemberResponse>('put', `/api/v1/member/change-pw?aui=${aui}`, data);
};

export const updateHandle = async (aui: string, data: UpdateHandleReq): Promise<SimpleStringResponse> => {
  return sendApiRequest<SimpleStringResponse>('put', `/api/v1/member/change-handle?aui=${aui}`, data);
};

export const setPassword = async (aui: string, data: SetPasswordReq): Promise<MemberResponse> => {
  return sendApiRequest<MemberResponse>('put', `/api/v1/member/set-pw?aui=${aui}`, data);
};
